import { AllocationDefinitionDTO } from "../DTO/allocationDefinitionDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateAllocationDefinitionRequest extends BasicRequest{
   
    public allocationDefinition! : AllocationDefinitionDTO;
    
    constructor(){
        super()
    }
}